
// const Container = styled.div`
//   width: 100%;
//   height: 100vh;

//   display: flex;
//   justify-content: center;
//   align-items: center;

//   .circle{
//     width: 120px;
//     height: 120px;
//     background-color: rebeccapurple;
//     border-radius: 50%;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     position: relative;

//     .inner-circle{
//       width: 40px;
//       height: 40px;
//       border-radius: 50%;
//       background-color: var(--color-main);
//       z-index: 20;

//       .stick {
//         width: 20px;
//         height: 500px; /* Çubuğun uzunluğu */
//         background-color: purple;
//         border-radius: 20px;
//         position: absolute;
//         top: 50%;
//         left: 50%;
//         transform-origin: bottom center; /* Çubuğun dönüş noktası alt kısmı olacak */
//         transform: translate(-50%, -50%) rotate(270deg); /* Çubuğun üst kısmını döndürüyoruz */
//       }
//     }
//   }
// `

// const KasaDefteri = () => {

//   return (
//     <Container>
//       <div className="circle">
//         <div className="inner-circle">
//           <div className="stick"></div>
//         </div>
        
//       </div>
//     </Container>
//   )
// }

// export default KasaDefteri


// import React from 'react';
// import styled, { keyframes } from 'styled-components';

// // İbre animasyonu: 0'dan 180 dereceye dönüş


//   0% {
//     transform: rotate(-90deg);
//   }

//   100% {
//     transform: rotate(90deg);
//   }


// `;






import { useSelector } from "react-redux"
import styled from "styled-components"
import PageTopTitle from "../../components/shared/PageTopTitle"
import darkLogo from "../../images/svg/colors/dark/kamyoon-dark.svg"
import lightLogo from "../../images/svg/colors/light/kamyoon-light.svg"

const Container = styled.div`
  width: 100%;
  height: 100%;
  .content{
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    height: 40vh;
    gap: 20px;
    img{
      width: 200px;
    }
    p{
      font-size: var(--font-size-lg);
      font-weight: var(--font-weight-lg);
    }
  }
`
const KasaDefteri = () => {
  const {theme} = useSelector((state) => state.layout)

  return (
    <Container>
      <PageTopTitle title={"Kasa Defteri"} position='sticky'/>
      <div className="content">
        <img src={theme === "light" ? lightLogo : darkLogo} alt="" />
        <p>Kasa Defteri sayfamız yakında hizmetinize sunulacaktır.</p>
      </div>
    </Container>
  )
}

export default KasaDefteri

// const Container = styled.div`
//   width: 100vw;
//   height: 100vh;
//   display: flex;
//   justify-content: center;
//   align-items: center;


//   .speedometer{
//     width: 500px;
//     height: 500px;
//     padding: 100px;
//     border-radius: 50%;
//     background: 
//     radial-gradient(#ffff 0 0) content-box,
//     conic-gradient(
//       from -90deg,
//       #c126c2 36deg,
//       #db5c23 0 72deg,
//       #f69220 0 108deg,
//       #8ba247 0 144deg,
//       #23b473 0 180deg,
//       #000 0
//     );
//     position: relative;
//   }

//   .needle{
//     position: absolute;
//     width: 380px;
//     height: 380px;
//     padding: 150px;
//     left: 50%;
//     top: 50%;
//     translate: -50% -50%;
//     border-radius: 50%;
//     background: 
//     conic-gradient(
//       from -90deg,
//       #c126c2 36deg,
//       #db5c23 0 72deg,
//       #f69220 0 108deg,
//       #8ba247 0 144deg,
//       #23b473 0 180deg,
//       #000 0
//     ) 0 -217px no-repeat,
//     radial-gradient(
//       from -90deg,
//       #c126c2 36deg,
//       #db5c23 0 72deg,
//       #f69220 0 108deg,
//       #8ba247 0 144deg,
//       #23b473 0 180deg,
//       #000 0
//     ) content-box;
//     /* rotate: 90deg; */
//     display: flex;
//     justify-content: center;
//     align-items: center;
//   };

//   .score{
//     /* rotate: calc(cos(var(--score) * 180deg / 100) * 90deg); */

//   }
// `

// const Ibre = () => {

//   return (

//     <Container>
//       <div className="speedometer">
//           <div className="needle"></div>
//       </div>
//     </Container>
//   )
// }

// export default Ibre